import { getManagementEditData, getManagementCountData, getUploadCountData, getSearchUserListListData, getSearchApproveUserListData, getUploadWithdrawData, getTableUploadData, getApprovalData, getEditDraftData, getEditDetailData, getUploadFileData,
  getTableData, getSegmentData, getFileListData, getFormulationIdData, getDetailData, getManagementPreviewData, getTradeNameIdData, getClaimData, handleEnable, setNewConcept, getTrend, getMediaList, getDetailByAuth, getUploadConceptCount, deleteDraft, setKeyProduct } from '@/axios/api/concept.js'
import { Message } from 'element-ui'
// data management 表格数据
const UPDATE_TABLEDATA = 'UPDATE_TABLEDATA'
// data upload 表格数据
const UPDATE_TABLEUPLOADDATA = 'UPDATE_TABLEUPLOADDATA'
// 表格总数
const UPDATE_TOTAL = 'UPDATE_TOTAL'
// 表格参数
const UPDATE_PARAMS = 'UPDATE_PARAMS'
const UPDATE_PAGER = 'UPDATE_PAGER'
// segment接口
const UPDATE_SEGMENT = 'UPDATE_SEGMENT'
// 删除file
const DELETE_UPLOADFILE = 'DELETE_UPLOADFILE'
// editDetail接口
const UPDATE_DETAIL = 'UPDATE_DETAIL'
// draft接口
const UPDATE_DRAFT = 'UPDATE_DRAFT'
// ManagementPreview接口
const UPDATE_MANAGEMENTPREVIEW = 'UPDATE_MANAGEMENTPREVIEW'
// UploadWithdraw接口
const UPDATE_WITHDRAW = 'UPDATE_WITHDRAW'
// approval接口
const GET_APPROVAL = 'GET_APPROVAL'
const GET_FILELISTS = 'GET_FILELISTS'
// management edit接口
const UPDATE_MANAGEMENTEDIT = 'UPDATE_MANAGEMENTEDIT'
// 新增第一步
const ONE_STEP = 'ONE_STEP'

// 第二步
const TWO_STEP_IDS = 'TWO_STEP_IDS'
const TWO_STEP_DATA = 'TWO_STEP_DATA'

// 第三步
const THREE_STEP_IDS = 'THREE_STEP_IDS'
const THREE_STEP_DATA = 'THREE_STEP_DATA'

const STEP = 'STEP'

const DETAIL = 'DETAIL'

const FORMULATIONIDDATA = 'formulationIdData'
const UPLOAD_IMAGE = 'UPLOAD_IMAGE'

const TRADENAMEIDS = 'TRADENAMEIDS'
const UPDATE_SEARCH = 'UPDATE_SEARCH'

const APPENDINGTOTAL = 'APPENDINGTOTAL'
const APPENDINGTOTAL_UPLOAD = 'APPENDINGTOTAL_UPLOAD'
const UPLOAD_SEARCHAPPROVAL = 'UPLOAD_SEARCHAPPROVAL'
const UPLOAD_SUBMITBY = 'UPLOAD_SUBMITBY'
const UPDATE_NEWLOADING = 'UPDATE_NEWLOADING'

// const UPDATE_ADD_NEW_STATUS = 'UPDATE_ADD_NEW_STATUS'

const state = {
  // data management
  tableData: [],
  // data upload
  tableUploadData: [],
  // data management 分页参数
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  // 表格查询参数
  params: {
    id: '',
    region: '',
    type: '',
    segment: '',
    submitBy: '',
    year: '',
    approver: '',
    newConcept: '',
    title: '',
    languageId: [],
    userId: '',
    roleId: '',
    keywordId: '',
    fileLanguageIds: [],
    keyProduct: ''
  },
  // data upload 分页参数
  pagerupload: {
    current: 1,
    size: 10,
    total: 0
  },
  // 表格查询参数
  paramsupload: {
    // areaId: '',
    // type: '',
    // segment: '',
    // position: '',
    // updateYear: '',
    // statuses: '',
    // uploader: '',
    size: 10,
    current: 1,
    desc: ['id']
  },
  /** *********CONCEPT SEGMENT**************/
  segmentList: [],

  addNew: {
    step: 1,
    oneStep: {

    },
    twoStep: {
      ids: {},
      twoStepData: {}

    },
    threeStep: {
      ids: {},
      threeStepData: {}
    },
    upload: {}
  },
  // addNewStatus: 1 // 1, 2, 3
  /** *********CONCEPT UPLOADFILE**************/
  uploadFileList: [],
  editDetailList: [],
  draftList: [],
  // 请求上传30个文件
  fileListUpload: [],
  approvalList: [],
  managementPreviewList: [],
  detail: {},
  formulationIdData: [], // 获取配方id
  withdrawList: [],
  uploadImage: [],
  tradeNameIds: [], // 获取tradeNameId
  /** 审批中的总条数 */
  appendingTotal: 0,
  /** upload审批中的总条数 */
  appendingTotalUpload: 0,
  searchApprovalList: [],
  submitByList: [],
  /* management edit */
  managementEditList: [],
  newLoading: false
}

const getters = {
  /** *********CONCEPT TABLE**************/
  tableData: state => state.tableData,
  tableUploadData: state => state.tableUploadData,
  pager: state => state.pager,
  params: state => state.params,
  /** *********CONCEPT SEGMENT**************/
  segmentList: state => state.segmentList.map(v => {
    return { label: v.name, value: v.id }
  }),
  uploadFileList: state => state.uploadFileList,
  oneStep: state => state.addNew.oneStep,
  /** 获取存草稿，步骤二后台所需数据 */
  twoStepIds: state => {
    return { ...state.addNew.oneStep, ...state.addNew.twoStep.ids }
  },
  /** 获取步骤二所需页面 */
  twoStepData: state => {
    return {...state.addNew.oneStep, ...state.addNew.twoStep.twoStepData}
  },
  upload: state => state.addNew.upload,
  /** 获取存草稿，步骤三后台所需数据 */
  threeStepIds: state => {
    return { ...state.addNew.oneStep, ...state.addNew.twoStep.ids, ...state.addNew.threeStep.ids }
  },
  /** 获取步骤三所需页面数据 */
  threeStepData: state => {
    return {...state.addNew.oneStep, ...state.addNew.twoStep.twoStepData, ...state.addNew.threeStep.threeStepData}
  },
  step: state => {
    return state.addNew.step
  },

  editDetailList: state => state.addNew.editDetailList,

  fileListUpload: state => state.fileListUpload,

  // upload: state => state.addNew.upload,
  draftList: state => state.addNew.draftList,

  approvalList: state => state.addNew.approvalList,
  managementPreviewList: state => state.managementPreviewList,
  formulationIdData: state => state.formulationIdData,
  detail: state => state.detail,
  withdrawList: state => state.withdrawList,
  uploadImage: state => state.uploadImage,
  tradeNameIds: state => state.tradeNameIds,
  appendingTotal: state => state.appendingTotal,
  appendingTotalUpload: state => state.appendingTotalUpload,
  searchApprovalList: state => state.searchApprovalList.map(v => {
    return { label: v.account, value: v.id }
  }),
  submitByList: state => state.submitByList.map(v => {
    return { label: v.account, value: v.id }
  }),
  managementEditList: state => state.managementEditList,
  newLoading: state => state.newLoading

}

const mutations = {
  /** *********CONCEPT TABLE**************/
  [UPDATE_TABLEDATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_TABLEUPLOADDATA] (state, tableUploadData) {
    state.tableUploadData = tableUploadData
  },
  [UPDATE_TOTAL] (state, total) {
    state.pager = { ...state.pager, total }
  },
  [UPDATE_PAGER] (state, pager) {
    state.pager = { ...state.pager, ...pager }
  },
  [UPDATE_PARAMS] (state, params) {
    state.params = params
  },
  /** *********CONCEPT SEGMENT**************/
  [UPDATE_SEGMENT] (state, segmentList) {
    // state.segmentParams = {...state.segmentParams,segmentParams}
    state.segmentList = segmentList
  },
  [DELETE_UPLOADFILE] (state, res) {
    state.uploadFileList.splice(state.uploadFileList.indexOf(res), 1)
  },
  // [UPDATE_ADD_NEW_STATUS](state, addNewStatus) {
  //   state.addNewStatus = addNewStatus
  // }

  /**  步骤一 */
  [ONE_STEP] (state, oneStep) {
    state.addNew.oneStep = oneStep
  },
  /**  步骤二 */
  [TWO_STEP_IDS] (state, twoStep) {
    state.addNew.twoStep.ids = twoStep
  },
  [TWO_STEP_DATA] (state, twoStep) {
    state.addNew.twoStep.twoStepData = twoStep
  },
  /**  步骤三 */
  [THREE_STEP_IDS] (state, threeStep) {
    state.addNew.threeStep.ids = threeStep
  },
  [THREE_STEP_DATA] (state, threeStep) {
    state.addNew.threeStep.threeStepData = threeStep
  },
  [STEP] (state, step) {
    state.addNew.step = step
  },
  [UPDATE_DETAIL] (state, editDetailList) {
    state.addNew.editDetailList = editDetailList
  },
  [UPDATE_DRAFT] (state, draftList) {
    state.addNew.draftList = draftList
  },
  [GET_APPROVAL] (state, approvalList) {
    state.addNew.approvalList = approvalList
  },
  [UPDATE_MANAGEMENTPREVIEW] (state, managementPreviewList) {
    state.managementPreviewList = managementPreviewList
  },
  [GET_FILELISTS] (state, fileListUpload) {
    state.fileListUpload = fileListUpload
  },
  [FORMULATIONIDDATA] (state, formulationIdData) {
    state.formulationIdData = formulationIdData
  },
  [DETAIL] (state, detail) {
    state.detail = detail
  },
  [UPDATE_WITHDRAW] (state, withdrawList) {
    state.withdrawList = withdrawList
  },
  [UPLOAD_IMAGE] (state, uploadImage) {
    state.uploadImage = uploadImage
  },
  [TRADENAMEIDS] (state, tradeNameIds) {
    state.tradeNameIds = tradeNameIds
  },
  [UPDATE_SEARCH] (state, { pager, params }) {
    state.pager = pager
    if (params) state.params = params
  },
  /** 获取审批中的总条数 */
  [APPENDINGTOTAL] (state, appendingTotal) {
    state.appendingTotal = appendingTotal
  },
  /** 获取我的上传审批中的总条数 */
  [APPENDINGTOTAL_UPLOAD] (state, appendingTotalUpload) {
    state.appendingTotalUpload = appendingTotalUpload
  },
  [UPLOAD_SEARCHAPPROVAL] (state, searchApprovalList) {
    state.searchApprovalList = searchApprovalList
  },
  [UPLOAD_SUBMITBY] (state, submitByList) {
    state.submitByList = submitByList
  },
  [UPDATE_MANAGEMENTEDIT] (state, managementEditList) {
    state.managementEditList = managementEditList
  },
  [UPDATE_NEWLOADING] (state, newLoading) {
    state.newLoading = newLoading
  }
}

const actions = {
  /**
   *
   * CONCEPT TABLE data managaement
   * @param {*} { commit }
   * @param {*} params
   */
  async getTableDataApi ({ commit }, params) {
    // 非数字类型不可搜索
    if (params.id && isNaN(params.id)) {
      commit(UPDATE_TABLEDATA, [])
      commit(UPDATE_TOTAL, 0)
      return
    }
    commit(UPDATE_NEWLOADING, true)
    try {
      // const { tableSource, size, current, desc } = { ...params }
      let { data: res } = await getTableData(params)
      // console.log(res.data);
      commit(UPDATE_TABLEDATA, res)
      commit(UPDATE_TOTAL, res.total)
    } catch (e) {}
    commit(UPDATE_NEWLOADING, false)
  },

  setParams ({ commit }, params) {
    commit(UPDATE_PARAMS, params)
  },
  setPager ({ commit }, params) {
    commit(UPDATE_PAGER, params)
  },
  /**
   * 我的上传表
   * CONCEPT TABLE data upload
   * @param {*} { commit }
   * @param {*} params
   */

  async getTableDataUploadApi ({ commit }, params) {
    // 非数字类型不可搜索
    if (isNaN(params.id)) {
      commit(UPDATE_TABLEDATA, [])
      commit(UPDATE_TOTAL, 0)
      return
    }
    commit(UPDATE_NEWLOADING, true)
    try {
      // const { tableSource, size, current, desc } = { ...params }
      let { data: res } = await getTableUploadData(params)
      // 更新表格数据
      commit(UPDATE_TABLEUPLOADDATA, res)
      commit(UPDATE_TOTAL, res.total)
    } catch (e) {}
    commit(UPDATE_NEWLOADING, false)
  },

  setUploadParams ({ commit }, params) {
    commit(UPDATE_PARAMS, params)
  },

  /**
   *
   * CONCEPT SEGMENT
   * @param {*} { commit }
   */
  async getSegmentDataApi ({ commit }) {
    // const {marketSegment,pid} = {...segmentParams}

    let segmentParams = {
      marketSegment: 0,
      pid: 0
    }
    let { data: res } = await getSegmentData({ ...segmentParams })
    // let { data: res } = await getSegmentData({params})
    // console.log("1111"+res.data);
    commit(UPDATE_SEGMENT, res)
    // commit(UPDATE_TOTAL, 10000)
  },
  /**
   *
   * step
   * @param {*} {commit}
   * @param {*} params
   */
  async getStepDataApi ({ commit }, params) {
    commit(STEP, params)
  },

  /**
   *
   *编辑新增
   * @param {*} { commit }
   * @param
   */
  async getEditDetailDataApi ({ commit }, params) {
    commit(UPDATE_NEWLOADING, true)
    try {
      let { data: res } = await getEditDetailData(params)
      commit(UPDATE_DETAIL, res)
    } catch (e) {}
    commit(UPDATE_NEWLOADING, true)
  },
  /**
   *
   *draft
   * @param {*} { commit }
   * @param {*} params
   */
  async getDraftDataApi ({ commit }, params) {
    try {
      const data = {
        ...params,
        segmentIds: params.segmentIds && params.segmentIds.length ? params.segmentIds.join(',') : '',
        languageId: params.type === 'Old'
          ? undefined
          : params.languageId && params.languageId.length ? params.languageId.join(',') : '',
        title: params.type === 'Old'
          ? params.title
          : params.languageId && params.languageId.includes(29) ? params.title : '',
        titleCn: params.languageId && params.languageId.includes(30) ? params.titleCn : '',
        titleJp: params.languageId && params.languageId.includes(687) ? params.titleJp : '',
        areaId: params.type === 'Old'
          ? params.areaId
          : params.areaId && params.areaId.length ? params.areaId.join(',') : '',
        roleIds: params.roleIds && params.roleIds.length ? params.roleIds.join(',') : '',
        userIds: params.userIds && params.userIds.length ? params.userIds.join(',') : '',
        fileIds: params.fileIds.map(v => v.id).join(','),
        cnDesc: params.languageId && params.languageId.includes(30) ? params.cnDesc : '',
        enDesc: params.languageId && params.languageId.includes(29) ? params.enDesc : '',
        jpDesc: params.languageId && params.languageId.includes(687) ? params.jpDesc : ''
      }
      let { data: res } = await getEditDraftData(data)
      commit(UPDATE_DRAFT, res)
      Message.success('success')
      return res
    } catch (e) {
      return false
    }
  },
  /**
   *
   * FILELIST
   * @param {*} { commit }
   * @param {*} params
   */
  async getFileListApi ({ commit }, params) {
    try {
      let { data: res } = await getFileListData(params)
      console.log(res)
      commit(GET_FILELISTS, res.data)
    } catch (e) {
    }
  },
  /**
   *
   * approver
   * @param {*} { commit }
   * @param {*} params
   */
  async getApprovalListApi ({ commit }, params) {
    try {
      let { data: res } = await getSearchApproveUserListData(params)
      commit(UPLOAD_SEARCHAPPROVAL, res)
      console.log(res)
    } catch (e) {
    }
  },
  /**
   *
   * approval
   * @param {*} { commit }
   * @param {*} params
   */
  async getSearchApprovalApi ({ commit }, params) {
    try {
      await getApprovalData(params)
    } catch (e) {
    }
  },
  /**
   *
   * getSubmitByApi
   * @param {*} { commit }
   * @param {*} params
   */
  async getSubmitByApi ({ commit }, params) {
    try {
      let { data: res } = await getSearchUserListListData(params)
      console.log(res)
      commit(UPLOAD_SUBMITBY, res)
    } catch (e) {
    }
  },
  /**
   * managementpreview
   * @param {*} { commit }
   * @param {*} params
   */
  async getManagementPreviewDataApi ({ commit }, params) {
    try {
      let { data: res } = await getManagementPreviewData(params)
      console.log(res)
      commit(UPDATE_MANAGEMENTPREVIEW, res)
    } catch (e) {
    }
  },
  // 清空参数
  clearParamsApi ({ commit }, pager) {
    const params = {
      id: '',
      region: '',
      type: '',
      segment: '',
      submitBy: '',
      year: '',
      approver: '',
      newConcept: '',
      languageId: [],
      fileLanguageIds: []
    }
    commit(UPDATE_SEARCH, { pager, params })
  },
  /**
   * withdrawList
   * @param {*} { commit }
   * @param {*} params
   */
  async getUploadWithdrawDataApi ({ commit }, params) {
    try {
      let { data: res } = await getUploadWithdrawData(params)
      commit(UPDATE_WITHDRAW, res)
    } catch (e) {
    }
  },
  /**
   * management edit
   * @param {*} { commit }
   * @param {*} params
   */
  async getManagementEditDataApi ({ commit }, params) {
    try {
      let { data: res } = await getManagementEditData(params)
      // if (res.errorCode === 50010) {
      //   this.$message('weight is defined')
      // }
      commit(UPDATE_MANAGEMENTEDIT, res)
    } catch (e) {
    }
  },

  /** ********* 步骤一的数据******** */
  async getOneStepDataApi ({commit}, params) {
    await commit(ONE_STEP, params)
  },

  /** ********* 步骤二的数据******** */
  async getTwoStepIdsApi ({commit}, params) {
    await commit(TWO_STEP_IDS, params)
  },
  async getTwoStepDataApi ({commit}, params) {
    await commit(TWO_STEP_DATA, params)
  },

  /** ********* 步骤三的数据******** */
  async getThreeStepIdsApi ({commit}, params) {
    await commit(THREE_STEP_IDS, params)
  },
  async getThreeStepDataApi ({commit}, params) {
    await commit(THREE_STEP_DATA, params)
  },

  /** ********* formulationID的数据******** */
  async getformulationIdDataApi ({commit}, params) {
    try {
      let {data: res} = await getFormulationIdData(params)
      return res
    } catch (e) {
    }
  },
  /** ********* tradeNameID的数据******** */
  async getTradeNameIdDataApi ({commit}, params) {
    try {
      let {data: res} = await getTradeNameIdData(params)
      return res.records
    } catch (e) {
    }
  },
  /** ********* 详细页的数据******** */
  async getDetailApi ({commit}, params) {
    try {
      let {data: res} = await getDetailData(params)
      commit(DETAIL, res)
    } catch (e) {
    }
  },
  async getDetailByAuthApi ({commit}, params) {
    try {
      let {data: res} = await getDetailByAuth(params)
      commit(DETAIL, res)
    } catch (e) {
    }
  },
  /** ********* claim的数据******** */
  async getClaimDataApi ({commit}, params) {
    try {
      let {data: res} = await getClaimData(params)
      return res
    } catch (e) {
    }
  },

  /** ********* 存图片的数据******** */
  async getUploadimageApi ({commit}, params) {
    try {
      let {data: res} = await getUploadFileData(params)
      commit(UPLOAD_IMAGE, res)
    } catch (e) {
    }
  },

  /** ********* 审批中的总条数的数据******** */
  async getAppendingTotalDataApi ({commit}, params) {
    // commit(APPENDINGTOTAL, params)
    try {
      let {data: res} = await getManagementCountData(params)
      commit(APPENDINGTOTAL, res)
    } catch (e) {
    }
  },
  /** ********* 审批中的总条数的数据******** */
  async getAppendingTotalUploadDataApi ({commit}, params) {
    // commit(APPENDINGTOTAL_UPLOAD, params)
    try {
      let {data: res} = await getUploadCountData(params)
      commit(APPENDINGTOTAL_UPLOAD, res)
    } catch (e) {
    }
  },
  clearDetailApi ({commit}) {
    commit(DETAIL, {})
  },
  async handleEnableApi ({commit}, params) {
    try {
      await handleEnable(params)
    } catch (e) {}
  },
  async setNewConceptApi ({commit}, params) {
    try {
      await setNewConcept(params)
    } catch (e) {}
  },
  async getTrendApi ({commit}, params) {
    try {
      const {data: res} = await getTrend(params)
      return res
    } catch (e) {}
  },
  // 获取media列表
  async getMediaApi ({ state, commit }, { keyword }) {
    try {
      const { data: res } = await getMediaList({
        size: 20,
        current: 1,
        keyword
      })
      return res || []
    } catch (e) {
      return []
    }
  },
  async getUploadConceptCountApi ({commit}, params) {
    try {
      const res = await getUploadConceptCount(params)
      return res
    } catch (e) {}
  },
  async deleteDraftApi ({ commit }, params) {
    try {
      const res = await deleteDraft(params)
      return res && res.errorCode === 200
    } catch (e) {
      return false
    }
  },
  // 设置 Key focus product
  async setKeyProductApi ({ commit }, params) {
    try {
      const res = await setKeyProduct(params)
      return res
    } catch (e) {
      return false
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
// setNewAddStatusApi(2)



// WEBPACK FOOTER //
// ./src/store/modules/concept.js